import React from 'react';
import pineconeImg from '../assets/pinecone-logo.png';

const logos = {
  openai: 'https://cdn.worldvectorlogo.com/logos/openai-2.svg',
  milvus: 'https://milvus.io/images/milvus_logo.svg',
  pinecone: pineconeImg,
  huggingface: 'https://huggingface.co/front/assets/huggingface_logo.svg',
  claude: 'https://www.anthropic.com/images/icons/claude-avatar.svg',
  git: 'https://git-scm.com/images/logos/downloads/Git-Icon-1788C.svg',
};

const faceShell = {
  position: 'absolute',
  width: '100px',
  height: '100px',
  background: '#15112A',
  border: '1px solid #666',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  padding: '6px 4px',
  boxSizing: 'border-box',
};

const labelStyle = {
  fontSize: 8,
  fontWeight: 600,
  letterSpacing: '0.05em',
  color: 'rgba(196, 188, 212, 0.95)',
  textTransform: 'uppercase',
  lineHeight: 1.2,
  textAlign: 'center',
  maxWidth: 90,
};

function CubeFace({ transform, imgSrc, alt, label, glow }) {
  return (
    <div style={{ ...faceShell, transform }}>
      <img
        src={imgSrc}
        alt={alt}
        style={{
          width: '34px',
          height: '34px',
          flexShrink: 0,
          filter: `brightness(0) invert(1) drop-shadow(0 0 4px ${glow})`,
        }}
      />
      <span style={labelStyle}>{label}</span>
    </div>
  );
}

const HeroImageAnimation = () => {
  return (
    <div style={{ perspective: '500px', width: '100px', height: '100px' }}>
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          transformStyle: 'preserve-3d',
          animation: 'spin 10s infinite linear',
        }}
      >
        <CubeFace
          transform="translateZ(50px)"
          imgSrc={logos.openai}
          alt="OpenAI"
          label="OpenAI"
          glow="#0ff"
        />
        <CubeFace
          transform="translateZ(-50px) rotateY(180deg)"
          imgSrc={logos.milvus}
          alt="Milvus"
          label="Milvus"
          glow="#0f0"
        />
        <CubeFace
          transform="rotateY(90deg) translateZ(50px)"
          imgSrc={logos.pinecone}
          alt="Pinecone"
          label="Pinecone"
          glow="#f0f"
        />
        <CubeFace
          transform="rotateY(-90deg) translateZ(50px)"
          imgSrc={logos.huggingface}
          alt="Hugging Face"
          label="Hugging Face"
          glow="#fa0"
        />
        <CubeFace
          transform="rotateX(90deg) translateZ(50px)"
          imgSrc={logos.claude}
          alt="Claude"
          label="Claude"
          glow="#f80"
        />
        <CubeFace
          transform="rotateX(-90deg) translateZ(50px)"
          imgSrc={logos.git}
          alt="Git"
          label="Git"
          glow="#f00"
        />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotateX(0deg) rotateY(0deg); }
          100% { transform: rotateX(360deg) rotateY(360deg); }
        }
      `}</style>
    </div>
  );
};

export default HeroImageAnimation;
